import type { ProfessionalTypeEnum } from '@gql/graphql';
import type { ModalData } from '@presentation/components/Modal';

export interface WhatsappModalData {
  modal: ModalData;
  onConfirm(): void;
  pro: WhatsappProDetails | undefined;
  breeder: WhatsappBreederDetails | undefined;
}

export interface WhatsappModalProps extends WhatsappModalData {}

export interface WhatsappModalFormValues {
  firstName: string;
  lastName: string;
  message?: string;
  email: string;
  phone: string;
  phonePrefixCountry: string;
  marketingEmailConsent: boolean;
}

export interface WhatsappProDetails {
  title?: string | null;
  avatar?: string | null;
  type: ProfessionalTypeEnum;
}
export interface WhatsappBreederDetails {
  title?: string | null;
  avatar?: string | null;
  location?: string | null;
  spokenLanguages?: string | null;
}
